import React from 'react';
import PropTypes from 'prop-types';
import { FDConfirmationDialog, FDSecondaryActionIconButton } from '@facet-wealth/design';
import useConfirmationDialogState from 'Hooks/useConfirmationDialogState';

const RestoreGeneratedDraftOption = ({
  meetingAgendaResource,
  handleChange,
}) => {
  const {
    dialogOpen,
    loading,
    handleClose,
    handleSubmit,
    handleOpen,
  } = useConfirmationDialogState({
    onSubmit: handleChange,
    closeOnSubmit: true,
  });

  const hasGeneratedContent = !!meetingAgendaResource?.attr('generatedContentUpdatedAt');

  if (!hasGeneratedContent) {
    return null;
  }

  return (
    <>
      <FDSecondaryActionIconButton
        onClick={handleOpen}
        icon="refresh"
        label="Restore FacetBot Draft"
      />
      <FDConfirmationDialog
        message="This will delete your current draft and replace it with the FacetBot generated draft."
        title="Are you sure?"
        onClose={handleClose}
        onConfirm={handleSubmit}
        loading={loading}
        open={dialogOpen}
      />
    </>
  );
};

RestoreGeneratedDraftOption.propTypes = {
  meetingAgendaResource: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default RestoreGeneratedDraftOption;
